import i18n from "../../../../../constants/i18n";
import { AUDITOR_PROMO_CODE_HEADERS } from "../../../../../constants/table-custom-headers/Auditor";
import getPromoCodeStore from "../../../../../stores/auditor-store/promocode-store";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Table from "../../../../../core/et3-table";

const AllPromoCodes = withLiteObserverAndTheme(() => {
  const { allPromocodesArray } = getPromoCodeStore().getPromoCodesArrays();

  return (
    <Et3Table
      columns={AUDITOR_PROMO_CODE_HEADERS}
      rows={allPromocodesArray}
      title={i18n.get("PROMO_CODES")}
      shouldBeFlagged={false}
      titleKey={"PROMO_CODES"}
    />
  );
});
export default AllPromoCodes;
